(() => {
  if (window.baesicChassisCountsReady) return;
  window.baesicChassisCountsReady = true;
  const requests = new Map();
  const load = async endpoint => {
    const products = new Map();
    let total, pages;
    for (let page = 1; page <= (pages || 1); page++) {
      const url = new URL(endpoint, location.origin);
      if (url.origin !== location.origin) throw new Error('Invalid count source');
      url.searchParams.set('page', page);
      const response = await fetch(url);
      if (!response.ok) throw new Error('Count request failed');
      const data = await response.json();
      if (data.version !== 1 || data.page !== page || !Array.isArray(data.products) || data.total > 25000) throw new Error('Incomplete catalog');
      if (page === 1) { total = data.total; pages = data.pages; }
      if (data.total !== total || data.pages !== pages) throw new Error('Catalog changed during count');
      data.products.forEach(product => products.set(product.id, product.chassis));
    }
    if (products.size !== total) throw new Error('Incomplete catalog');
    const counts = new Map();
    products.forEach(ids => new Set(ids).forEach(id => counts.set(id, (counts.get(id) || 0) + 1)));
    return counts;
  };
  const initialize = () => document.querySelectorAll('[data-chassis-count-source]:not([data-count-started])').forEach(section => {
    section.dataset.countStarted = 'true';
    const endpoint = section.dataset.chassisCountSource;
    if (!requests.has(endpoint)) requests.set(endpoint, load(endpoint));
    requests.get(endpoint).then(counts => {
      section.querySelectorAll('[data-chassis-count-id]').forEach(label => {
        const count = counts.get(label.dataset.chassisCountId) || 0;
        label.textContent = (count === 0 ? section.dataset.countZero : count === 1 ? section.dataset.countOne : section.dataset.countMany).replace('__COUNT__', String(count));
      });
    }).catch(() => {
      requests.delete(endpoint);
      section.querySelectorAll('[data-chassis-count-id]').forEach(label => { label.textContent = section.dataset.countUnavailable; });
    });
  });
  document.addEventListener('shopify:section:load', initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, {once:true});
  else initialize();
})();
